module.exports = __webpack_public_path__ + "09_hair_silver.17117e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/09_hair_silver.png
// module id = hqQh
// module chunks = 0